import React from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import Hero from '../../components/hero';
import Comics from '../../components/comics';
import Archive from '../../components/archive';
import Series from '../../components/series';
import { receiveData } from '../../actions/getData';
import { templateSelector } from '../../selectors/templateSelector';
import { comicsSelector, seriesSelector } from '../../selectors/comicsSelector';
import styles from './styles.less';


class MainContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const { hero, layout } = this.props.home;
        const artists = this.props.artists;
        const archive = this.props.series;
        const currentSeries = this.props.currentSeries;
        const vars = [
            'var strPageName = "Index"',
            'var strSectionName = "Comics"',
            'var strSubSectionName = ""'
        ];

        return (
            <div className={ styles.root }>
                <Helmet>
                    <html lang='en' />
                    <meta charSet='utf-8' />
                    { !!currentSeries &&
                        <title>{ `Adult Swim Comics - ${currentSeries.title}` }</title>
                    }
                    { !currentSeries &&
                        <title>Adult Swim Comics</title>
                    }
                    <meta
                        content='Weekly comics presented by Adult Swim for your viewing pleasure.'
                        name='description'
                    />
                    <meta
                        content='width=device-width,initial-scale=1'
                        name='viewport'
                    />
                    <meta
                        content="Adult Swim Comics, Scorpion Dagger, Buff Dudes, Buttfield, Jeroom, Street Wizard, Finish This, Crapland, A Portion of Dirt, Trust Zabo"
                        name="keywords"
                    />
                    { !currentSeries &&
                    <link
                        href='https://www.adultswim.com/comics'
                        rel='canonical'
                    />
                    }
                    { !!currentSeries &&
                    <link
                        href={ `https://www.adultswim.com/comics/${currentSeries.id}` }
                        rel='canonical'
                    />
                    }
                    <script>{ vars.join('; ') }</script>
                </Helmet>

                { /* CONTENT WRAPPER (defines a max-width) */ }
                <div className={ styles.contentWrapper }>

                    <Hero
                        className={ styles.hero }
                        data={ hero }
                    />

                    <Comics
                        className={ styles.comics }
                        data={ layout }
                    />

                </div>

                <Archive
                    className={ styles.archive }
                    data={ archive }
                />

                { !!currentSeries &&
                <Series
                    artist={ artists[currentSeries.artist] }
                    className={ styles.series }
                    data={ currentSeries }
                />
                }

            </div>
        );
    }

}
if (!process.env.CLIENT) {
    const axios = require('axios');

    MainContainer.getInitialData = async (match, { PAGES_API_URL }) => {
        const [ incoming ] = await Promise.all([
            axios.request({ baseURL: PAGES_API_URL, url: '/v1/view/comics-www/all?flatten=true' }),
        ]);

        return receiveData(incoming.data.data.rows);

    }
}

function mapStateToProps (state, props) {
    return {
        home: templateSelector(state),
        series: comicsSelector(state),
        artists: state.artists,
        currentSeries: seriesSelector(state, props)
    };
}


export default connect(mapStateToProps)(MainContainer);



// WEBPACK FOOTER //
// ./src/client/containers/main/index.js